import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { ColorsComponent } from '../../../../../pages/datasets/colors/colors.component';
import { ColorEditComponent } from '../../../../../pages/datasets/colors/edit/color-edit.component';

export const colors: Route = {
  path: 'colors',
  title: 'nav.datasets.colors',
  data: {
    icon: SbIcons.colorPalette,
    breadcrumb: 'nav.datasets.colors',
    id: RoutingID.colors,
  },
  children: [
    {
      path: '',
      component: ColorsComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'colors-edit/:colorID',
      title: 'nav.datasets.colors.edit',
      data: {
        icon: SbIcons.edit,
        breadcrumb: 'nav.datasets.colors.edit',
        id: RoutingID.colorEdit,
      },
      children: [
        {
          path: '',
          component: ColorEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'colors-create',
      title: 'nav.datasets.colors.create',
      data: {
        icon: SbIcons.plus,
        breadcrumb: 'nav.datasets.colors.create',
        id: RoutingID.colorCreate,
      },
      children: [
        {
          path: '',
          component: ColorEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
